import React, { useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import SubscriptionModal from "../../components/SubscriptionModal";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainContainer from "../../components/MainContainer";
import moment from "moment";
import { useDate } from "../../hooks/useDate";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
}));

const Contacts = () => {
  const classes = useStyles();
  const { user, socket } = useContext(AuthContext);

  const [loading,] = useState(false);
  const [, setPageNumber] = useState(1);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [hasMore,] = useState(false);
  const [dueDate, setDueDate] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [isCreatingInvoice, setIsCreatingInvoice] = useState(false);
  const { returnDays } = useDate();

  const handleOpenContactModal = async () => {
    setIsCreatingInvoice(true);
    try {
      // Verificar se a empresa tem documento válido
      if (!user?.company?.document) {
        toast.error("Sua empresa precisa ter um documento (CPF/CNPJ) cadastrado para processar pagamentos. Entre em contato com o suporte.");
        return;
      }

      const doc = user.company.document.replace(/\D/g, "");
      if (doc.length !== 11 && doc.length !== 14) {
        toast.error("Documento da empresa inválido. O CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos. Entre em contato com o suporte.");
        return;
      }

      // Criar uma invoice para o processo de pagamento
      const { data } = await api.post("/invoices", {
        companyId: user.companyId,
        dueDate: moment().add(30, 'days').format('YYYY-MM-DD'),
        detail: "Renovação de assinatura",
        status: "pending",
        value: user?.company?.plan?.amount || 0,
        users: user?.company?.plan?.users || 0,
        connections: user?.company?.plan?.connections || 0,
        queues: user?.company?.plan?.queues || 0,
        useWhatsapp: user?.company?.plan?.useWhatsapp || true,
        useFacebook: user?.company?.plan?.useFacebook || true,
        useInstagram: user?.company?.plan?.useInstagram || true,
        useCampaigns: user?.company?.plan?.useCampaigns || true,
        useSchedules: user?.company?.plan?.useSchedules || true,
        useInternalChat: user?.company?.plan?.useInternalChat || true,
        useExternalApi: user?.company?.plan?.useExternalApi || true
      });
      
      setSelectedInvoice(data);
      setSelectedContactId(null);
      setContactModalOpen(true);
    } catch (error) {
      console.error("Erro ao criar invoice:", error);
      toastError(error);
      toast.error("Erro ao iniciar processo de assinatura. Tente novamente.");
    } finally {
      setIsCreatingInvoice(false);
    }
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setSelectedInvoice(null);
    setContactModalOpen(false);
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  useEffect(() => {
    const currentDueDate = localStorage.getItem("dueDate");
    if (currentDueDate !== "" && currentDueDate !== "null") {
      setDueDate(moment(currentDueDate).format("DD/MM/YYYY"));
    }
  }, []);

  return (
    <MainContainer className={classes.mainContainer}>
      <SubscriptionModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        Invoice={selectedInvoice}
        contactId={selectedContactId}
      ></SubscriptionModal>

      <MainHeader>
        <Title>Assinatura</Title>
      </MainHeader>
      <Grid item xs={12} sm={4}>
        <Paper
          className={classes.mainPaper}
          variant="outlined"
          onScroll={handleScroll}
        >

          <div>
            <TextField
              id="outlined-full-width"
              label="Período de Licença"
              // defaultValue={`Sua licença vence em ${returnDays(user?.company?.dueDate)} dias!`}
              defaultValue={returnDays(user?.company?.dueDate) === 0 ? `Sua licença vence em hoje!` : `Sua licença vence em ${returnDays(user?.company?.dueDate)} dias!`}
              fullWidth
              margin="normal"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ readOnly: true, }}
              variant="outlined"
            />

          </div>

          <div>
            <TextField
              id="outlined-full-width"
              label="Email de cobrança"
              defaultValue={user?.email}
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
            />
          </div>

          <div>
            <TextField
              id="outlined-full-width"
              label="Documento da empresa"
              defaultValue={user?.company?.document || "Não cadastrado"}
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
              error={!user?.company?.document}
              helperText={!user?.company?.document ? "Documento obrigatório para pagamentos PIX" : ""}
            />
          </div>

          <div>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenContactModal}
              disabled={isCreatingInvoice}
              fullWidth
            >
              {isCreatingInvoice ? "Carregando..." : "Assine Agora!"}
            </Button>
          </div>

        </Paper>
      </Grid>
    </MainContainer>
  );
};

export default Contacts;
